const FACEBOOK = 'facebook';
const GDN = 'gdn';
const GTM = 'agency-gtm';
const KNOWLEDGE_CAMPUS = 'knowledge-campus';
const OUTBRAIN = 'outbrain';
const PEARCH_ADSENSE = 'pearch-adsense';
const TABOOLA = 'taboola';
const WBT = 'westbay-tech';

module.exports = {
  FACEBOOK,
  GDN,
  GTM,
  KNOWLEDGE_CAMPUS,
  OUTBRAIN,
  PEARCH_ADSENSE,
  TABOOLA,
  WBT,
};
